import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Settings } from 'lucide-react';

const PlataformaConfiguracoes = () => {
  return (
    <div className="space-y-6 animate-fade-in" data-testid="plataforma-configuracoes-page">
      <div>
        <h2 className="text-2xl font-bold text-primary font-['Outfit'] mb-1">Configurações</h2>
        <p className="text-muted-foreground">Configurações da plataforma</p>
      </div>

      <Card className="border-slate-100">
        <CardContent className="pt-12 pb-12">
          <div className="text-center">
            <Settings className="w-12 h-12 mx-auto mb-3 text-muted-foreground opacity-50" />
            <p className="text-muted-foreground">Configurações em desenvolvimento</p>
            <p className="text-sm text-muted-foreground mt-1">
              Esta seção será implementada em breve
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PlataformaConfiguracoes;
